module.exports = __webpack_public_path__ + "img/files.502a7ee3.svg";